export const SUBSCRIPTION_GET_SUBSCRIBERS_REQUEST = "SUBSCRIPTION_GET_SUBSCRIBERS_REQUEST";
export const SUBSCRIPTION_GET_SUBSCRIBERS_SUCCESS = "SUBSCRIPTION_GET_SUBSCRIBERS_SUCCESS";
export const SUBSCRIPTION_SUBSCRIBE_REQUEST = "SUBSCRIPTION_SUBSCRIBE_REQUEST";
export const SUBSCRIPTION_SUBSCRIBE_SUCCESS = "SUBSCRIPTION_SUBSCRIBE_SUCCESS";
export const SUBSCRIPTION_UNSUBSCRIBE_REQUEST = "SUBSCRIPTION_UNSUBSCRIBE_REQUEST";
export const SUBSCRIPTION_UNSUBSCRIBE_SUCCESS = "SUBSCRIPTION_UNSUBSCRIBE_SUCCESS";